module.exports = __webpack_public_path__ + "static/media/DESTELLOS.11b1d25b.png";